import { BaseContainerModel } from '../base-container.model';
export class PaymentTxnStatusRefNoResponseModel {
  constructor(
    public response_txn_status: string, //mandatory
    public response_txn_ref_no: string //mandatory
  ) {
  }
}
